import React from 'react'
import { Box, Button, Typography, useTheme } from '@mui/material'
import { Modal } from '../../../components/_EOS/Modal/Modal'

interface MermaModalProps {
  isOpen: boolean
  onClose: () => void
  onMermaResponse: (isDamaged: boolean) => void
  isLoading: boolean
}

export const MermaModal: React.FC<MermaModalProps> = ({
  isOpen,
  onClose,
  onMermaResponse,
  isLoading
}) => {
  const theme = useTheme()

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Estado del Producto"
      maxWidth="sm"
    >
      <Box style={{ textAlign: 'center', padding: '16px 0' }}>
        <Typography variant="body1" gutterBottom>
          ¿El producto requiere ir a calidad?
        </Typography>
        <Typography
          variant="body2"
          style={{ color: theme.palette.text.secondary, marginBottom: 24 }}
        >
          Si requiere ir a calidad, se moverá a CALIDAD-TRANSFERENCIA.
        </Typography>

        <Box display="flex" justifyContent="center" style={{ gap: 16 }}>
          <Button
            variant="outlined"
            onClick={() => onMermaResponse(false)}
            disabled={isLoading}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={() => onMermaResponse(true)}
            disabled={isLoading}
            style={{
              backgroundColor: theme.palette.warning.main,
              color: theme.palette.warning.contrastText
            }}
          >
            Sí
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
